import { render } from "./registrationStatistics.vue?vue&type=template&id=88086704&scoped=true"
import script from "./registrationStatistics.vue?vue&type=script&lang=js"
export * from "./registrationStatistics.vue?vue&type=script&lang=js"

import "./registrationStatistics.vue?vue&type=style&index=0&id=88086704&lang=scss&scoped=true"
import "./registrationStatistics.vue?vue&type=style&index=1&id=88086704&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88086704"]])

export default __exports__